// Revenda MasterX — edite aqui os pacotes, textos e FAQ.
import { BRAND } from "../config/brand";

export const brl = (n) => n.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const packageMessage = (credits, price) => `Olá! Quero ser revendedor MasterX – pacote de ${credits} créditos (R$ ${brl(price)})`;
export const MIN_CREDITS = 20;
export const resellerWaLink = (msg) => `https://wa.me/${BRAND.whatsappNumber}?text=${encodeURIComponent(msg)}`;
export const RESELLER_GENERIC_MSG = "Olá! Quero ser revendedor MasterX. Pode me explicar como funciona?";

export const resellerPackages = [
  { credits: 20, price: 80, badge: "Inicial" },
  { credits: 50, price: 175, badge: "Popular" },
  { credits: 100, price: 300, badge: "Mais vendido", highlight: true },
  { credits: 200, price: 500, badge: "Melhor custo" },
];

export const resellerBenefits = [
  { icon: "panel", title: "Painel próprio de revenda", desc: "Crie, renove e gerencie seus clientes em poucos cliques, de qualquer lugar." },
  { icon: "infinite", title: "Créditos que não expiram", desc: "Compre quando quiser e use no seu ritmo. Seu saldo fica guardado." },
  { icon: "support", title: "Suporte dedicado", desc: "Atendimento exclusivo para revendedores via WhatsApp, rápido e humano." },
  { icon: "profit", title: "Alta margem de lucro", desc: "Você define o preço final. Quanto maior o pacote, maior o seu lucro." },
  { icon: "speed", title: "Velocidade & Estabilidade", desc: "Servidores robustos para seus clientes assistirem sem travar." },
];

export const resellerSteps = [
  { title: "Escolha o pacote", desc: "Selecione a quantidade de créditos ideal para começar." },
  { title: "Fale no WhatsApp", desc: "Confirme o pacote e faça o pagamento via PIX com nossa equipe." },
  { title: "Receba o painel", desc: "Seu acesso ao painel de revenda é liberado rapidamente." },
  { title: "Comece a vender", desc: "Crie testes e clientes, defina seus preços e lucre." },
];

export const resellerFaq = [
  { q: "O que é um crédito?", a: "Cada crédito equivale a 1 mês de acesso para um cliente. Ex.: um plano trimestral usa 3 créditos." },
  { q: "Qual o mínimo por recarga?", a: `O mínimo por recarga é de ${MIN_CREDITS} créditos (R$ 80,00). Nos pacotes maiores o crédito sai a partir de R$ 2,50.` },
  { q: "Os créditos expiram?", a: "Não. Os créditos ficam no seu painel até você usá-los." },
  { q: "Preciso ter experiência para revender?", a: "Não. Nossa equipe te orienta desde o primeiro acesso ao painel até a sua primeira venda." },
  { q: "Como recebo meu acesso ao painel?", a: "Após a confirmação do pagamento via PIX, enviamos seu login de revendedor pelo WhatsApp." },
  { q: "Posso definir meu próprio preço de venda?", a: "Sim. Você é livre para definir o valor cobrado dos seus clientes e montar sua margem de lucro." },
];
